import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchSettings,
  fetchSettingById,
  createSetting as createSettingApi,
  updateSetting as updateSettingApi,
  deleteSetting as deleteSettingApi,
} from "../../helpers/apis";
import { toast } from 'react-toastify';

// Get all settings
export const getSettings = createAsyncThunk(
  "settings/getAll",
  async (_, thunkAPI) => {
    try {
      const res = await fetchSettings();
      // Normalize: if res is array, use it; if object with data/settings, use that; else empty array
      let settingsArr = [];
      if (Array.isArray(res)) {
        settingsArr = res;
      } else if (res && Array.isArray(res.data)) {
        settingsArr = res.data;
      } else if (res && Array.isArray(res.settings)) {
        settingsArr = res.settings;
      }
      return settingsArr;
    } catch (err) {
      toast.error(err?.msg || "Error fetching settings");
      throw err;
    }
  }
);

// Get by ID
export const getSetting = createAsyncThunk(
  "settings/getOne",
  async (id, thunkAPI) => {
    try {
      const res = await fetchSettingById(id);
      return res.data;
    } catch (err) {
      toast.error(err?.msg || "Error fetching setting");
      throw err;
    }
  }
);

// Create
export const createSetting = createAsyncThunk(
  "settings/create",
  async (data, thunkAPI) => {
    try {
      const res = await createSettingApi(data);
      // If res.data is an array, return the last item (the new setting)
      if (Array.isArray(res.data)) {
        return res.data[res.data.length - 1];
      }
      return res.data;
    } catch (err) {
      toast.error(err?.msg || "Error creating setting");
      throw err;
    }
  }
);

// Update by ID
export const updateSetting = createAsyncThunk(
  "settings/update",
  async ({ id, data }, thunkAPI) => {
    try {
      const res = await updateSettingApi(id, data);
      toast.success(res.message || "Setting updated!");
      return res.data;
    } catch (err) {
      toast.error(err?.msg || "Error updating setting");
      throw err;
    }
  }
);

// Delete by ID
export const deleteSetting = createAsyncThunk(
  "settings/delete",
  async (id, thunkAPI) => {
    try {
      await deleteSettingApi(id);
      return id;
    } catch (err) {
      toast.error(err?.msg || "Error deleting setting");
      throw err;
    }
  }
);
